__turbopack_context__.v({
  "dropdownHeadVertical": "LeadTheFutureLp-module-scss-module__uaX8AW__dropdownHeadVertical",
  "heading": "LeadTheFutureLp-module-scss-module__uaX8AW__heading",
  "headingSelected": "LeadTheFutureLp-module-scss-module__uaX8AW__headingSelected",
  "headingWrapper": "LeadTheFutureLp-module-scss-module__uaX8AW__headingWrapper",
  "headingWrapperInnerSelected": "LeadTheFutureLp-module-scss-module__uaX8AW__headingWrapperInnerSelected",
  "imageEnd": "LeadTheFutureLp-module-scss-module__uaX8AW__imageEnd",
  "leadTheFutureContainer": "LeadTheFutureLp-module-scss-module__uaX8AW__leadTheFutureContainer",
  "leadTheFutureContainerInner": "LeadTheFutureLp-module-scss-module__uaX8AW__leadTheFutureContainerInner",
  "leadTheFutureDownArrowDown": "LeadTheFutureLp-module-scss-module__uaX8AW__leadTheFutureDownArrowDown",
  "leadTheFutureDownArrowDownInitital": "LeadTheFutureLp-module-scss-module__uaX8AW__leadTheFutureDownArrowDownInitital",
  "logoHeadingContainer": "LeadTheFutureLp-module-scss-module__uaX8AW__logoHeadingContainer",
  "mWebContent": "LeadTheFutureLp-module-scss-module__uaX8AW__mWebContent",
  "midline": "LeadTheFutureLp-module-scss-module__uaX8AW__midline",
  "rightContent": "LeadTheFutureLp-module-scss-module__uaX8AW__rightContent",
});
